import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './index';

/**
 * Typed version of useDispatch hook
 *
 * Use throughout the app instead of plain `useDispatch` for type safety
 */
export const useAppDispatch: () => AppDispatch = useDispatch;

/**
 * Typed version of useSelector hook
 *
 * Use throughout the app instead of plain `useSelector` for type safety
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
